import { BasicPermissionItem } from '../../PermissionItem'
import {
  EditPackageNumberName,
  GiveDisposition,
  Revert,
  Simple,
  Unlock,
  CreateViewEditSoftRemoveRestore,
} from '../../common'
import { DSLog } from '../../../cimsPage/instances/ds'
import { DSStatus } from '../../../statuses/ds'
const { DisciplineAction } = DSStatus

const object = 'Design Submittal'
const page = DSLog
const ds = CreateViewEditSoftRemoveRestore({
  object,
  page,
  create: '3C27D640-DC68-48FB-BA78-7D6A72C32D1B',
  view: 'BB2F177D-797F-4714-844C-1E67FAD97DBB',
  edit: 'CF41F91E-82A3-472E-8D5E-8B52152CB346',
  removeRestore: 'DC0F7162-DD4D-4640-8E98-42C2EDCBD9A5',
})
export const CreateDesignSubmittal = ds.Create
export const ViewDesignSubmittal = ds.View
export const EditDesignSubmittal = ds.Edit
export const RemoveRestoreDesignSubmittal = ds.RemoveRestore

export const RouteDesignSubmittal = Simple({
  id: 'B80E4D46-6898-4922-B6CE-3A53BFB4EFAF',
  action: 'Route',
  object,
  page,
})

export const ReviewAllDesignSubmittal = new BasicPermissionItem({
  id: 'CD686DAE-8D13-40E7-876D-8E5F6E51AFA4',
  page,
  name: 'Review All Disciplines',
  action: `check all boxes during ${DisciplineAction.name}`,
  allowMixedCase: true,
})

export const CommentOnDesignSubmittal = Simple({
  id: 'EA6134F4-F8CA-4ED6-8448-4EE11E764DB5',
  action: 'Comment on',
  object,
  page,
})

export const EditNumberNameDesignSubmittal = EditPackageNumberName({
  id: '19DAF251-4470-4FD2-94C8-60915273D8B0',
  object,
  page,
})

export const GiveDispositionDesignSubmittal = GiveDisposition({
  id: '5ABB92C6-13D1-4B6C-B134-3C42A98015C3',
  object,
  page,
})

export const RevertDesignSubmittal = Revert({
  id: '053976D6-282C-40F1-BCBC-D93BFF9A71EB',
  object,
  page,
})

export const UnlockDesignSubmittal = Unlock({
  id: '85019301-A178-40EA-82E9-AB6E80235967',
  object,
  page,
})

export type DSLogPermission =
  | typeof CreateDesignSubmittal
  | typeof ViewDesignSubmittal
  | typeof EditDesignSubmittal
  | typeof RemoveRestoreDesignSubmittal
  | typeof RouteDesignSubmittal
  | typeof ReviewAllDesignSubmittal
  | typeof CommentOnDesignSubmittal
  | typeof EditNumberNameDesignSubmittal
  | typeof GiveDispositionDesignSubmittal
  | typeof RevertDesignSubmittal
  | typeof UnlockDesignSubmittal
